import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ReservationModel } from 'src/app/models/reservation.model';
import { ReservationTableComponent } from '../reservation-table/reservation-table.component';

@Component({
  selector: 'app-checkin-tab',
  standalone: true,
  imports: [ReservationTableComponent],
  templateUrl: './checkin-tab.component.html',
  styleUrl: './checkin-tab.component.css'
})

export class CheckInTabComponent {
  @Input() dataSource!: MatTableDataSource<ReservationModel>;
  @Input() totalCount!: number;
  @Input() pageSize!: number;
  @Input() pageIndex!: number;
  @Input() isLoading!: boolean;
  @Input() errorClassFn!: (row: ReservationModel) => string;
  @Input() canCheckInFn!: (reservation: ReservationModel) => boolean;
  @Input() canCheckOutFn!: (reservation: ReservationModel) => boolean;
  @Input() canCancelFn!: (reservation: ReservationModel) => boolean;
  @Input() canEditFn!: (reservation: ReservationModel) => boolean;
  @Input() canRegisterPaymentFn!: (reservation: ReservationModel) => boolean;


  displayedColumns = ['responsible', 'document', 'checkOutDate', 'id', 'status', 'actions'];

  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() actionClick = new EventEmitter<any>();
}
